import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";
import type { TypeLargeCtaSkeleton } from "./TypeLargeCta";

/**
 * Fields type definition for content type 'TypeLandingPageHeader'
 * @name TypeLandingPageHeaderFields
 * @type {TypeLandingPageHeaderFields}
 * @memberof TypeLandingPageHeader
 */
export interface TypeLandingPageHeaderFields {
    /**
     * Field type definition for field 'internalTitle' (Internal Title)
     * @name Internal Title
     * @localized false
     */
    internalTitle?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'header' (Header)
     * @name Header
     * @localized true
     */
    header?: EntryFieldTypes.Text;
    /**
     * Field type definition for field 'headerDescription' (Header Description)
     * @name Header Description
     * @localized true
     */
    headerDescription?: EntryFieldTypes.Text;
    /**
     * Field type definition for field 'cta' (CTA)
     * @name CTA
     * @localized true
     */
    cta?: EntryFieldTypes.EntryLink<TypeLargeCtaSkeleton>;
    /**
     * Field type definition for field 'headerImage' (Header Image)
     * @name Header Image
     * @localized false
     */
    headerImage?: EntryFieldTypes.AssetLink;
    /**
     * Field type definition for field 'shadowColor' (Shadow Color)
     * @name Shadow Color
     * @localized false
     */
    shadowColor?: EntryFieldTypes.Symbol<"blue" | "dark-blue" | "gold" | "green" | "light-blue" | "magenta" | "red" | "yellow">;
}

/**
 * Entry skeleton type definition for content type 'landingPageHeader' (Landing Page Header)
 * @name TypeLandingPageHeaderSkeleton
 * @type {TypeLandingPageHeaderSkeleton}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-28T18:40:08.259Z
 * @version 33
 */
export type TypeLandingPageHeaderSkeleton = EntrySkeletonType<TypeLandingPageHeaderFields, "landingPageHeader">;
/**
 * Entry type definition for content type 'landingPageHeader' (Landing Page Header)
 * @name TypeLandingPageHeader
 * @type {TypeLandingPageHeader}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-28T18:40:08.259Z
 * @version 33
 */
export type TypeLandingPageHeader<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeLandingPageHeaderSkeleton, Modifiers, Locales>;

export function isTypeLandingPageHeader<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeLandingPageHeader<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'landingPageHeader'
}
